import { ITPARule } from "./EstimateEngine/EstimateEngineTypes";
export enum TicSheetType {
	None = "",
	Type1 = "Type1",
	Type1_1 = "Type1_1",
	Exterior = "exterior",
}

export enum EQuantityTypesLow {
	NoQuantity = "no quantity",
	QuantityAsMultiplierBadSpelling = "quantity as multuplier",
	QuantityAsMultiplier = "quantity as multiplier",
	QuantityAsDivider = "quantity as divider",
	QuantityAsValue = "quantity as value",
	QuantityAsDividedValue = "quantity as divided value",
	QauntityAsSubtract = "quantity as subtract",
}

export interface IOrganizationCreateUser {
	email: string;
	role: string;
	firstName?: string;
	lastName?: string;
	photoURL?: string;
}
export interface IOrganizationUser extends IOrganizationCreateUser {
	organizationId: string;
	isRegistered?: boolean;
	organizationName?: string;
	lassoUserId: string;
	uid: string;
}

export enum EstimaticsFileTypes {
	tic = "tic",
	image = "image",
	other = "other",
	MITIGATION_REPORT = "mitigation_report",
	CONTENTS_TEMPLATE = "contents_template",
}
export interface IOrganizationCreateObject {
	customSettings: any;
	aiModels: string;
	organizationName: string;
	recipientsXNAddress: string;
	organizationDescription: string;
	organizationAddress: string;
	organizationLogo?: string;
}

export interface IOrganizationObject extends IOrganizationCreateObject {
	organizationTPARules?: ITPARule[];
	allowedDomain?: string;
	organizationId: string;
	classificationModel?: string;
	layoutModel?: string;
	creator: IOrganizationUser;
	createDate: Date;
	users?: IOrganizationUser[];
	featureFlags?: { [featureName: string]: boolean };
	pdfExportConfig?: OrganizationLevelPDFContent;
}

export type OrganizationLevelPDFContent = {
	organizationId: string;
	organizationName: string;
	letterHeads: LetterHeadDetails[];
	topLeftText?: string[];
	footerImageUrl?: string;
	title: string;
	headerInfo: HeaderInfoItem[];
	terms?: string; // Legal Terms of the PDF (usually talking about how long the estimate is valid for)
	footerLines?: string[]; // Footer text (usually the company name and address)
};

export type LetterHeadDetails = {
	path: string;
	scale: number;
	margin: {
		top: number;
		bottom: number;
		left: number;
		right: number;
	};
	previewScale?: number;
	previewAlignment?: "left" | "center" | "right";
	officeNames: string[];
};

// header-info for PDF export. key is what the user sees in the PDF, estimateField is the actual field from the estimate data. value is the value of the field.
// for example: { key: "Customer Name", estimateField: EstimateFieldsForExportHeader.Assignee, value: "John Doe" }
export type HeaderInfoItem = {
	key: string;
	estimateField: EstimateFieldsForExportHeader;
	value?: string;
};

export enum EstimateFieldsForExportHeader {
	ProjectName = "projectName",
	PropertyAddress = "propertyAddress",
	Assignee = "assignee",
	CurrentDate = "currentDate",
	OrganizationName = "organizationName",
}

export enum EVeriskMappingAction {
	None = 0,
	Approve = 1,
	Reject = 2,
	Ignore = 3,
	BadCombo = 4,
}
